import React from 'react';
import Cookies from 'js-cookie';

export const Login = async (user_id, user_pass) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/token/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user_id: user_id, user_pass: user_pass }),
        });

        if (response.ok) {
            const data = await response.json();
            Cookies.remove('token');
            Cookies.set('token', data.token, { expires: 7 }); // Store token as a cookie with 7-day expiration
            window.location.href = '/console'; // Redirect to the dashboard
        } else {
            console.error('Login failed:', response.status);
        }
    } catch (error) {
        console.error('Login failed:', error);
    }
};

export const useLogout = () => {
    const Logout = React.useCallback(async () => {
      try {
        const token = Cookies.get("token");
        await fetch(`${process.env.REACT_APP_API_URL}/console/logout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token: token }),
        });
        Cookies.remove("token"); // Remove the token cookie
        window.location.href = "/console/login"; // Redirect to the login page
      } catch (error) {
        console.error("Logout failed:", error);
      }
    }, []);
  
    return Logout;
  };